import Controller from '@ember/controller';

export default class HotelSettingsController extends Controller {}
